<div class="locate-main">
    <div class="pop-up-heading">Locate Us</div>
    <div class="col-12">
        <div class="mapouter">
            <div class="gmap_canvas">
                <iframe
                    width="600"
                    height="307"
                    id="gmap_canvas"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.4821818178634!2d72.83814391489997!3d18.998462887132405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7cf5614f65741%3A0x6166e0c04ad59473!2sITI%20House!5e0!3m2!1sen!2sin!4v1638962436673!5m2!1sen!2sin" 
                    frameborder="0"
                    scrolling="no"
                    marginheight="0"
                    marginwidth="0"
                ></iframe>
            </div>
        </div>
    </div>
    <div class="col-12 iti-address">
        <br>
        <br>
        ITI Asset Management Limited
        ITI House, Building no. 36,
        Dr. R. K. Shirodkar Marg, Parel,
        Mumbai 40001
        <span class="view-larger-map">
            <br>
            <br>
            <u>
                <a 
                href="https://www.google.com/maps?ll=18.998463,72.840333&z=16&t=m&hl=en&gl=IN&mapclient=embed&cid=7018544185797350515"
                target="_blank"> View Larger Map </a>
            </u>
            <br>
            <br>
        </span>
    </div>


</div>

<iframe src="" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>